import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LayoutTemplate } from './layout-template';
import { CustomHttpHeaders } from 'cl-common-angular';
import { Observable } from 'rxjs';
import { refCount, publishReplay, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LayoutTemplateService {
    private readonly routePrefix: string = '/api/layouttemplate';
    private layoutTemplates: Observable<LayoutTemplate[]>;
    constructor(private http: HttpClient) { }

    // This doesn't change so no need to keep calling the api
    getLayoutTemplates(): Observable<LayoutTemplate[]> {
        if (!this.layoutTemplates)
            this.layoutTemplates = this.http.get<LayoutTemplate[]>(
                `${this.routePrefix}`,
                { headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' }) }
            ).pipe(
                tap((layouts: LayoutTemplate[]) => {
                    layouts.map(x => x.layoutType = parseInt(x.thumbnailURL[x.thumbnailURL.lastIndexOf('.png') - 1], 10));
                }),
                publishReplay(1), // this tells Rx to cache the latest emitted
                refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
            );
        return this.layoutTemplates;
    }
}
